export default "__VITE_ASSET__d229dd28__"